import { createSlice } from '@reduxjs/toolkit';
import { getAllProperties, getProblems } from './thunks';

// Initial state for Redux store:
export const initialStateProperties = {
  properties: {
    total: 0,
    properties: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  problems: [],
  loading: false,
};

const propertiesSlice = createSlice({
  name: 'properties',
  initialState: initialStateProperties, // Define initial state
  reducers: {
    setProperties: (state: any, action: any) => {
      state.properties = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllProperties.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllProperties.fulfilled, (state, action) => {
      state.properties = action.payload;
      state.loading = false;
    });
    builder.addCase(getProblems.fulfilled, (state, action) => {
      state.problems = action.payload;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setProperties } = propertiesSlice.actions;

// Export reducer generated by "createSlice()":
export default propertiesSlice.reducer;
